import React from "react";

const HappyCustomers = () => {
  return (
    <div className="w-full bg-[#E5ECEF] py-6 sm:py-6 my-3 sm:my-12"> {/* Grey strip */}
      <div className="max-w-7xl mx-auto flex flex-wrap justify-around items-center px-2"> {/* Flex container for responsive horizontal layout */}
        
        {/* Column 1 */}
        <div className="flex flex-col items-center font-medium text-center min-w-[90px] leading-none">
          <p className="text-xl sm:text-3xl pb-1">100+</p>
          <p className="text-sm sm:text-lg">Happy Customers</p>
        </div>
        
        {/* Column 2 */}
        <div className="flex flex-col items-center font-medium text-center min-w-[90px] leading-none">
          <p className="text-xl sm:text-3xl pb-1">50+</p>
          <p className="text-sm sm:text-lg">Partners</p>
        </div>
        
        {/* Column 3 */}
        <div className="flex flex-col items-center font-medium text-center min-w-[90px] leading-none">
          <p className="text-xl sm:text-3xl pb-1">25+</p>
          <p className="text-sm sm:text-lg">Members</p>
        </div>
        
      </div>
    </div>
  );
};

export default HappyCustomers;
